<script setup lang="ts">
const appConfig = useAppConfig();
const colorMode = useColorMode();

onMounted(() => {
  // Force to light mode
  colorMode.preference = "light";
  colorMode.value = "light";
});
</script>

<template>
  <UApp
    :toaster="appConfig.toaster"
    :tooltip="appConfig.tooltip"
  >
    <NuxtLoadingIndicator color="#668362" :height="3" />
    <NoScript>
      Mohon aktifkan JavaScript untuk menggunakan situs ini.
    </NoScript>

    <NuxtPage />
  </UApp>
</template>
